import { Component, TemplateRef, input } from '@angular/core';

import { CalendarDayModule, CalendarEvent } from 'angular-calendar';
import { Subject } from 'rxjs';

@Component({
  selector: 'cam-calendar-by-day',
  imports: [CalendarDayModule],
  templateUrl: './calendar-by-day.component.html',
  styleUrls: ['./calendar-by-day.component.scss'],
})
export class ByDayComponent {
  viewDate = input<Date>(new Date());

  events = input<CalendarEvent[]>([]);

  eventTemplate = input.required<TemplateRef<any>>();

  hourSegmentHeight = input<number>(130);

  refresh = input.required<Subject<void>>();
}
